module.exports = __webpack_public_path__ + "static/media/bw.9145c2d2.svg";